/* global flatpickr http loadEventSliders toggleEventsFilterModal */
const serviceFilterEventsAsideDatePicker = {
	el: {
		body: document.body,
		asideDatePickerContainer: document.querySelector('.js-aside-date-picker'),
		flatPickerContainer: document.querySelector('.js-init-date-picker'),
		mainContainer: document.querySelector('.js-filter-events')
	},

	fxFilterEvents(element) {
		if (!element) return

		// set variables let (let it change)
		let filterRegion
		let filterLocation

		// populate variables
		filterRegion = this.fxGetFilterID('regionEvents')
		filterLocation = this.fxGetFilterID('locationEvents')

		// get language that has to be sent to api
		const languageParameter = this.el.body.getAttribute('data-language')

		// set formData
		const formData = {
			eventDate: 'all',
			region: filterRegion ? filterRegion : 'allRegions',
			location: filterLocation ? filterLocation : 'allLocations'
		}

		// get attributes in order to call api when page is loaded
		const apiEndPointOnLoadPage = this.el.asideDatePickerContainer.getAttribute('data-action-news-cards')

		// callback function 
		const callback = (response, data) => {
			// call function that will fill summary results
			this.fxRenderSummaryEventsResults(response, data)

			//update datepicker
			this.fxInitFlatpickr(this.el.flatPickerContainer, response, data)
			// console.log(response, data)
		}

		// call api
		http.fxPost(apiEndPointOnLoadPage, formData, callback, languageParameter)
	},

	fxBuildCardWhenThereIsNoEvent() {
		// get attributes in order to call api
		const cardEmptySrcImage = this.el.asideDatePickerContainer.getAttribute('data-card-empty-src')

		// get attributes in order to call api
		const cardEmptyCopy = this.el.asideDatePickerContainer.getAttribute('data-card-empty-copy')

		// check if user already opened gallery, if yes we remove everything inside modal
		document.querySelector('.aside-date-picker__slider-wrap') && document.querySelector('.aside-date-picker__slider-wrap').remove()

		const cardEmptyNoEvent =
			`
			<div class="aside-date-picker__slider-wrap">
				<div class="card-beta card-beta-dynamic">
					<figure class="card-beta__figure">
						<img class="card-beta__image img-full-width"
							src="${cardEmptySrcImage}" 
							alt="${cardEmptyCopy}"
						>
					</figure>
					<div class="card-beta__content">
						<h2 class="card-beta__heading">${cardEmptyCopy}</h2>
					</div>
				</div>
					
			</div>
		`

		// insert wrap container inside container (aside-gallery-modal) that is already in the DOM
		document.querySelector('.aside-date-picker__slider').insertAdjacentHTML('beforeend', cardEmptyNoEvent)
	},

	fxBuildSliderWithCards(response, data) {
		// check if response is success
		if (response.status === 200) {
			// check if user already opened gallery, if yes we remove everything inside modal
			document.querySelector('.aside-date-picker__slider-wrap') && document.querySelector('.aside-date-picker__slider-wrap').remove()

			// save container that goes inside aside-gallery-modal
			const cardEventOnSlider =
				`
					<div class="aside-date-picker__slider-wrap">
						<div class="swiper-container js-slider js-slider-destroy-on-screen-wide"
							data-slider-small="1" data-slider-medium="2.3" data-slider-large="3" data-slider-space-between="30">
							<div class="swiper-wrapper">

							</div>
						</div>
						<div class="swiper-pagination">
							
					</div>
				`

			// insert wrap container inside container (aside-gallery-modal) that is already in the DOM
			document.querySelector('.aside-date-picker__slider').insertAdjacentHTML('beforeend', cardEventOnSlider)

			// do a loop in data variable in order to get each content inside array
			data.map(el => {
				// get selector swiper wrapper that is inside modal and insert node element
				document.querySelector('.aside-date-picker__slider-wrap .swiper-wrapper').innerHTML +=
					`
					
					<div class="swiper-slide" >
						<a class="card-beta" href=${el.eventSrc}>
							<figure class="card-beta__figure">
								<img class="card-beta__image img-full"
									src="${el.eventImage}" 
									alt="${el.eventHeading}"
								>
							</figure>
							<div class="card-beta__content">
								<div class="card-beta__caption">
									<span class="card-beta__caption-lead">${el.eventDate}</span>
								</div>
								<h2 class="card-beta__heading">${el.eventHeading}</h2>
							</div>
						</a>
					</div>
				`
			})
			setTimeout(() => loadEventSliders.fxInitSlider(document.querySelector('.js-slider')), 1)
		}
	},

	fxHandleGetEventInfoFromUniqueDay(data, submissionType) {

		// save in a variable the day that user is on page
		let findSelectedDateOnLoadPage

		// save in a variable the day that user clicked on datepicker
		let findSelectedDateOnFilterItems

		// save in a variable parameter that goes with apiEndPoint
		let getApiParameter

		// save endPoint that will be used to call api
		let apiEndPoint

		// get attributes in order to call api
		const actionAttribute = this.el.asideDatePickerContainer.getAttribute('data-action-news-cards')

		// check if page has been load or user clicked on datepicker
		if (submissionType === 'load') {
			// get atribute from element that has class today - it returns a string with date "YYYY-MM-DD"
			findSelectedDateOnLoadPage = document.querySelector('.today') && document.querySelector('.today').getAttribute('aria-label')

			// we loop through response from api and find which event date is equal atribute saved before
			getApiParameter = data.items.find(el => el.eventDate === findSelectedDateOnLoadPage)

			// if we don´t find any date that is equal to atribute saved before we return a card saying that there are no events
			if (!getApiParameter) {
				this.fxBuildCardWhenThereIsNoEvent()
				return
			}

		} else {
			// get atribute from element that has class selected - it returns a string with date "YYYY-MM-DD"
			findSelectedDateOnFilterItems = document.querySelector('.selected').getAttribute('aria-label')

			// we loop through response from api and find which event date is equal atribute saved before
			getApiParameter = data.items.find(el => el.eventDate === findSelectedDateOnFilterItems)

			// if we don´t find any date that is equal to atribute saved before we return a card saying that there are no events
			if (!getApiParameter) {
				this.fxBuildCardWhenThereIsNoEvent()
				return
			}
		}

		// get apiEndPoint 
		apiEndPoint = `${actionAttribute}${getApiParameter.eventDate} `

		// get language that has to be sent to api
		const languageParameter = this.el.body.getAttribute('data-language')

		// set variables let (let it change)
		let filterRegion
		let filterLocation

		// populate variables
		filterRegion = this.fxGetFilterID('regionEvents')
		filterLocation = this.fxGetFilterID('locationEvents')

		// set formData
		const formData = {
			eventDate: getApiParameter.eventDate,
			region: filterRegion ? filterRegion : 'allRegions',
			location: filterLocation ? filterLocation : 'allLocations'
		}

		// callback function 
		const callback = (response, data) => {
			// call function that will build cards
			this.fxBuildSliderWithCards(response, data)
		}

		// GET function - from @http.js file
		http.fxPost(apiEndPoint, formData, callback, languageParameter)
	},

	fxInitFlatpickr(el, response, data) {

		if (response.status === 200) {
			// function responsible for color each date picker that has an event
			const fxHandleColorPickerDate = (data, submissionType) => {
				// first we loop through all the dates that are in the response
				data.items.forEach(cardEvent => {
					// then we loop through all the dates that are in the flatpickr date picker
					document.querySelectorAll('.flatpickr-day').forEach(el => {
						// we save in a variable the atribute value of the date picker - it comes like this: "YYYY-MM-DD" - you can change it ate ariaDateFormat inside flatpickrOptions
						const dateOnPicker = el.getAttribute('aria-label')

						// check if date on response is equal to date on flatpickr date picker
						if (cardEvent.eventDate === dateOnPicker) {
							// if yes we add class active on the date picker
							el.classList.add('is-active')
						}
					})
				})

				// than we call this function in order to build cards
				this.fxHandleGetEventInfoFromUniqueDay(data, submissionType)
			}

			const flatpickrOptions = {
				locale: el.dataset.language,
				inline: true,
				dateFormat: 'Y-m-d',
				ariaDateFormat: 'Y-m-d',

				onReady: () => {
					fxHandleColorPickerDate(data, 'load')
				},

				onChange: () => {
					fxHandleColorPickerDate(data, 'filter')
				},

				onMonthChange: () => {
					fxHandleColorPickerDate(data, 'load')
				},

				onYearChange: () => {
					fxHandleColorPickerDate(data, 'load')
				}
			}

			flatpickr(el, flatpickrOptions)
		}

	},

	fxHandleFilterOnChangeSelectOrInput(el) {
		// check if element exists
		if (!el) return

		// Responsible for set values of radio buttons and select elements on data attribute called "data filter id" and make sure that when user select mobile version, the desktop version is selected as well
		toggleEventsFilterModal.fxHandleSelectAndInputValue(el)

		// filter results on change of radio button or select
		this.fxFilterEvents(this.el.mainContainer)
	},

	fxGetSelectedFilterForSummaryResults(filterId) {
		// get selected filter type
		const typeSelected = document.querySelector(`[data-filter-type="${filterId}"`)
		// save which select option has been selected
		const optionSelected = typeSelected.querySelector('select').options.selectedIndex
		// return text from this option selected - this way we make sure that we return the exact same value as the one in select element
		return typeSelected.querySelector('select').options[optionSelected].text
	},

	fxRenderSummaryEventsResults(response, data) {
		if (response.status === 200) {

			// set the number of results with data.length
			document.querySelector('.js-filter-summary-counter').textContent = data.totalRecords

			// save variables for later use
			let filterRegion
			let filterLocation

			// populate variables 
			filterRegion = this.fxGetSelectedFilterForSummaryResults('regionEvents')
			filterLocation = this.fxGetSelectedFilterForSummaryResults('locationEvents')

			// set each result with variables created above
			document.querySelector('.js-filter-summary-first-selected').textContent = filterRegion
			document.querySelector('.js-filter-summary-second-selected').textContent = filterLocation
		}
	},

	fxGetFilterID(filterId) {
		// find filter type from parameter and get filter ID
		return document.querySelector(`[data-filter-type="${filterId}"`).getAttribute('data-filter-id')
	},

	events() {
		// Responsible for first time initialization of the flatpickr date picker and call api
		this.fxFilterEvents(this.el.asideDatePickerContainer)

		//update calendar on input/select change according to region/location
		this.el.mainContainer.querySelectorAll('.js-filter-change-listener').forEach((el) => {
			el.addEventListener('change', (e) => {
				this.fxHandleFilterOnChangeSelectOrInput(e)
			})
		})
	},

	init() {
		if (!this.el.mainContainer) return
		this.events()
	}
}

serviceFilterEventsAsideDatePicker.init()